import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { layoutTokens } from "@/shared/theme";

export const MembershipLink = () => (
  <Box
    component={RouterLink}
    to="/subscription"
    sx={{
      mt: layoutTokens.sectionGap,
      p: layoutTokens.panelPadding,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 2,
      border: "1px solid",
      borderColor: "divider",
      bgcolor: "background.paper",
      color: "inherit",
      textDecoration: "none",
      "&:hover": {
        bgcolor: "primary.main",
        borderColor: "primary.main",
        color: "background.default",
        "& .MuiTypography-root": { color: "background.default" },
      },
    }}
  >
    <Box>
      <Typography variant="caption" sx={{ color: "secondary.main", fontWeight: 800, letterSpacing: "0.1em" }}>
        ♛ NIKOLA BASIC
      </Typography>
      <Typography sx={{ mt: 0.35, fontWeight: 800, fontSize: "0.95rem" }}>Membership, reads, and billing</Typography>
    </Box>
    <Typography variant="caption" sx={{ color: "primary.main", fontWeight: 800, letterSpacing: "0.08em" }}>
      VIEW →
    </Typography>
  </Box>
);
